module.exports = __webpack_public_path__ + "static/media/ai_swiper.d1a63b30.jpg";